/**
 * Checks if a value is a non-empty string.
 *
 * @param value - The value to be checked.
 *
 * @returns - `true` if the value is a non-empty string, `false` otherwise.
 *
 * @example
 *   if (isNonEmptyTrimmedString('hello')) {
 *     // Executes if the value is a non-empty string
 *   }
 */
export const isNonEmptyTrimmedString = (value: unknown): value is string => {
  return typeof value === 'string' && value.trim().length > 0;
};
